/**
 * Ryan O'Dowd
 * 2022-05-15
 * © Copyright 2022 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
/* @TODO:
import {
  Platform,
} from 'react-native';
*/

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    container: {
      alignItems: 'center',
      color: colors.white,
      fontSize: globalScale * 12,
      fontFamily: fonts.primaryBold,
      textAlign: 'center',
    },
    ringWrapper: (ringSize) => {
      return {
        borderRadius: globalScale * ringSize, // @TODO: must be half of AnimatedCircularProgress.size, and i don't think it is right now...not sure what this actually changes
      };
    },
    progressTextWrapper: (__ringSize) => {
      return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        // @TODO: width: Platform.OS === 'web' ? '100%' : (ringSize - 8),
        // @TODO: height: Platform.OS === 'web' ? '100%' : (ringSize - 8),
      };
    },
    progressText: {
      color: colors.white,
      textAlign: 'center',
    },
    peanutsProgressText: {
      // @TODO: fontSize: globalScale * 16,
    },
    progressCaption: {
      color: colors.white,
      fontSize: globalScale * 14,
      paddingTop: globalScale * 4,
      fontFamily: fonts.primaryBold,
      textAlign: 'center',
    },
  };
};

export default getStyles;
